import React from "react";
import styled from "styled-components";
import { default as constants } from "../../utils/constants";
import media from "../../utils/media";
const Container = styled.div ``;
const ControlContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  ${media.up.md `
    justify-content: ${(props) => props.hasFilters ? "space-between" : "flex-end"};
  `};
  margin-bottom: 20px;
  ${media.down.mdl `
    margin-left: ${(props) => props.hasResultSummary && "0px"};
  `}
  ${media.down.sml `
    margin: 0 20px 20px 10px;
  `};
`;
const ResultsSummaryDiv = styled.div `
  display: none;
  ${media.up.lg `
    display: block;
  `};
`;
function ResultBlock({ header, content, nature, filters, buttonBar, resultsSummary }) {
    const hasControls = buttonBar || filters;
    const controlsOnTop = nature === constants.RESULT_HEADER_NATURE.SMALL;
    const hasResultSummary = !!resultsSummary;
    return (<Container>
      {hasControls && controlsOnTop && (<ControlContainer hasFilters={!!filters || hasResultSummary} hasResultSummary={hasResultSummary}>
          {filters}
          {buttonBar}
        </ControlContainer>)}
      {resultsSummary && <ResultsSummaryDiv>{resultsSummary}</ResultsSummaryDiv>}
      {header}

      {hasControls && !controlsOnTop && (<ControlContainer hasFilters={!!filters || hasResultSummary} hasResultSummary={hasResultSummary}>
          {filters ? filters : resultsSummary}
          {buttonBar}
        </ControlContainer>)}
      {content}
    </Container>);
}
export default React.memo(ResultBlock);
